(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rq-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',(event)=>{document.querySelectorAll('.rq-menu-dropdown[open],.rq-mobile-menu[open]').forEach((menu)=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;});});
document.addEventListener('keydown',(event)=>{if(event.key==='Escape')document.querySelectorAll('.rq-menu-dropdown[open],.rq-mobile-menu[open]').forEach((menu)=>{menu.open=false;menu.querySelector('summary').focus();});});
import('@shopify/events').then(({ StandardEvents }) => {
  if (!StandardEvents?.cartLinesUpdate || window.rqCartSubscribed) return;
  window.rqCartSubscribed = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!event.promise) return;
    event.promise.then(async () => {
      const link = document.querySelector('[data-rq-cart]');
      if (!link) return;
      const response = await fetch(`${link.getAttribute('href')}.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count)) return;
      document.querySelectorAll('[data-rq-cart]').forEach((item) => {
        item.querySelector('[data-rq-cart-count]').textContent = String(cart.item_count);
        item.setAttribute('aria-label', item.dataset.rqCartLabel.replace('__COUNT__', String(cart.item_count)));
      });
    }).catch(() => {});
  });
}).catch(() => {});

  } catch(e) { console.error(e); }
})();
})();
